import dialogs from '@/mixins/dialogs';
(async () => require('@/styles/app.scss'))();

export default {
  install (Vue) {
    Vue.mixin(
      dialogs
    );
  }
}